import brand from '@helpers/brand';
import styled from 'styled-components';

const Wrapper = styled.footer`
  background-color: ${brand.red.base};
  overflow: hidden;
`;

const Contents = styled.div`
  overflow: hidden;
`;

export default {
  Wrapper,
  Contents,
};
